// Global game configuration
// Change QUESTIONS_PER_RUN to quickly adjust the number of questions/trials
// for Games 1–9. All games should import this value.

export const QUESTIONS_PER_RUN = 20;
